/* LastOccurrenceStatusComponent.js */

"use strict";
const _ = require("lodash");
const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl.DefaultColumnComponent;
const Renderer = require("./LastOccurrenceStatusRenderer");

class LastOccurrenceStatusComponent extends DefaultColumnComponent {
    constructor(value) {
        super(value);
        this._value = value;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /* *****************************************
    /* START PUBLIC API METHODS
    /* ***************************************** */
    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setLastOccurrenceStatus(newVal);
        }
    }

    getValue() {
        return this.getLastOccurrenceStatus();
    }

    setLastOccurrenceStatus(newVal) {
        this._value = newVal;
        this.emit("LastOccurrenceStatus", newVal);
        return this;
    }

    getLastOccurrenceStatus() {
        return this._value;
    }

    /* *****************************************
    /* END PUBLIC API METHODS
    /* ***************************************** */
}

module.exports = LastOccurrenceStatusComponent;
